import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
// Self-hosted Inter (no render-blocking Google Fonts request, no font-swap CLS)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
// Self-hosted Barlow Condensed for headings & numeric callouts (RTS brand typography)
import '@fontsource/barlow-condensed/600.css';
import '@fontsource/barlow-condensed/700.css';
import '@fontsource/barlow-condensed/800.css';
import '@fontsource/barlow-condensed/900.css';
import './index.css';
import './styles/site.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered pages ship static markup: hydrate it (no flash, instant paint).
// A plain CRA load has an empty #root: create a fresh root instead.
if (container.hasChildNodes()) {
  hydrateRoot(container, app, {
    // Our prerender captures the client-rendered DOM (outerHTML), which — unlike
    // React's own SSR — omits the text-node boundary markers. That makes React
    // reconcile a few adjacent text nodes on first paint. It's fully recoverable and
    // the rendered content is byte-identical (verified), so we swallow ONLY these
    // benign hydration reconciliations and still surface every other error.
    onRecoverableError: (error: unknown) => {
      const msg = String((error as any)?.message ?? error);
      if (/(hydrat|did not match|#(418|421|423|425))/i.test(msg)) return;
      // eslint-disable-next-line no-console
      console.error(error);
    },
  });
} else {
  createRoot(container).render(app);
}

reportWebVitals();
